'use client'

import type { AppShellProps } from '@/components/layout/AppShell.types'
import { HubeeShell } from '@/components/layout/HubeeShell'

import RoomBackground from '../room/RoomBackground'

export default function PromanityShell(
  props: AppShellProps
) {
  const sellerId = Number(props.sellerId || 0)

  return (
    <HubeeShell
      {...props}
      immersive
      slots={{
        ...props.slots,
        background: (
          <RoomBackground sellerId={sellerId} />
        ),
      }}
    />
  )
}